(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('CuestionarioService', CuestionarioService);

    CuestionarioService.$inject = ['$resource'];
    
    function CuestionarioService ($resource) {
    	var resourceUrl = 'apo/autoevaluacion/:ambito/:profesor';
    	
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'obtener': {
            	url:'apo/autoevaluacion/:ambito/:profesor/:modelo/:nivel/:tipoauto',
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
